export default "/images/logo.svg?e3a2016f92943bf5a435b2ab614df1b0";